import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import SidebarMenu from './components/SidebarMenu';
import Topbar from './components/Layout/Topbar';
import AuthService from './utils/auth';
import './App.css';

const { Sider, Content } = Layout;

const App = ({ useSimpleLayout = true }) => {
  const location = useLocation();

  useEffect(() => {
    // 统一的认证检查
    if (!AuthService.isAuthenticated() && !location.pathname.includes('/login')) {
      window.location.href = '/login';
    }
  }, [location.pathname]);

  // 如果是登录页面，由 AppRouter 处理，这里直接渲染 Outlet
  if (location.pathname.includes('/login')) {
    return <Outlet />;
  }

  return (
    <Layout style={{ minHeight: '100vh' }} className="admin-layout">
      <Sider
        width={248}
        breakpoint="lg"
        collapsedWidth={0}
        className="admin-sider"
      >
        <SidebarMenu />
      </Sider>

      <Layout className="admin-main">
        <div className="admin-topbar">
          <Topbar />
        </div>
        <Content className="admin-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;